module.exports = __webpack_public_path__ + "static/img/sf3.4351f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sf3.png
// module id = c2zr
// module chunks = 1